import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getFAQById, updateFAQ, postFAQ } from '../../../../api/faq'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'


function getEmptyFAQ() {
  return {
    question: {},
    answer: {},
    order: 0
  }
}

export default function EditFAQsPage() {
  const [faq, setFaq] = useState(getEmptyFAQ())
  const faqId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (faqId) {
      getFAQById(faqId).then(res => {
        if (res.status === 200) {
          setFaq(res.data)
          disableLoadingData()
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not get FAQ.' })
        history.push('/faqs')
      })
    } else {
      disableLoadingData()
    }
  }, [faqId, disableLoadingData, history])

  function saveFAQ() {
    if (faqId) {
      updateFAQ(faqId, faq).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          history.push('/faqs')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    } else {
      postFAQ(faq).then(res => {
        if (res.status === 200 || res.status === 201) {
          alertSuccess({ title: 'Saved!', customMessage: 'FAQ successfully created.' })
          history.push('/faqs')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not create FAQ.' })
      })
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ') return
      if (!faq[element]) faq[element] = {}
      let newFaq = faq[element]
      newFaq[lang] = event.target.value
      setFaq({ ...faq, [element]: newFaq })
    } else setFaq({ ...faq, [element]: event.target.value })
  }

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === ' ') return
      if (!faq[element]) faq[element] = {}
      let newFaq = faq[element]
      newFaq[lang] = value
      setFaq({ ...faq, [element]: newFaq })
    } else setFaq({ ...faq, [element]: value })
  }

  const handleNumberChange = (field) => (event) => {
    const raw = event.target.value
    const num = raw === '' ? 0 : Number(raw)
    setFaq({ ...faq, [field]: num })
  }

  const renderMultilanguageTabContent = lang => {
    return (
      <>
        <TextField
          id={`question`}
					label="Question"
          value={(faq.question && faq.question[lang]) || ''}
          onChange={handleChange('question', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
          fullWidth
        />
        <Editor
          body={(faq.answer && faq.answer[lang]) || ''}
          setBody={new_body => handleChangeEditor('answer', lang, new_body)}
          className='max-height'
          lang={lang}
          placeholder={'Enter answer content here...'}
        />
      </>
    )
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title={faqId ? 'Edit FAQ' : 'Create FAQ'}>
        </CardHeader>
        <CardBody>
          <TextField
            id="order"
            label="Order"
            type="number"
            value={faq.order || 0}
            onChange={handleNumberChange('order')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            inputProps={{ min: 0 }}
            helperText="Order in which the FAQ will appear (lower numbers appear first)"
          />
          <MultilanguageTabBlock
						multilanguageTabContent = {renderMultilanguageTabContent}
					/>
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/faqs')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => saveFAQ()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        {faqId ? 'Save FAQ' : 'Create FAQ'}
      </Button>
    </>
  );
}

